// extracted by mini-css-extract-plugin
module.exports = {"shades":"_1tb0048lMOD6pMzNp7QE1C","shades__active-shade":"_2wFlwRSjNx6waYRH48KNcl","shades__shade-detail":"_1jnKyyLdHCaBSZBbAefbgX","shades__wrapper":"_1r1WMGA60T2SZZ7mZsDe3V"};